import { DatePicker, Input, Table, Modal, Divider } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const paymentStatusCode = ['SCHEDULE', 'COMPLETE', 'CANCEL'];
const paymentStatusString = {
  SCHEDULE: '배당예정',
  COMPLETE: '배당완료',
  CANCEL: '배당취소',
}
class BbtAirdropLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.bbtAirdropLogList,[10,pageNum],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };

  render() {
    const { tables } = this.state;
    const columns = [
      {
        title: "분배일자",
        dataIndex: "airdropDate",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "아이디",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "분배수량",
        dataIndex: "amount",
        className: "support-column-number fs-15 lh-21",
        render: data => amountFormat(data, 402)
      },
      {
        title: "취소수량",
        dataIndex: "amountCancel",
        className: "support-column-number fs-15 lh-21",
        render: data => amountFormat(data, 402)
      },
      {
        title: "분배일시",
        dataIndex: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: data => data ? moment(data).format('YYYY-MM-DD HH:mm:ss') : '-'
      },
    ];
    

    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
            
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.status == 'COMPLETE' ? "blue" : record.status == 'CANCEL' ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default BbtAirdropLog;
